export const getNumberResponsive = (responsive) => {
    const newResponsive = {};
    for (let key in responsive) {
        newResponsive[key] = Number(responsive[key]);
    }
    return newResponsive;
};
